<header>
  <h1 mat-dialog-title>Configuration</h1>
  <aside>
    <mat-icon fontIcon="close" matTooltip="Close" matTooltipShowDelay="500" (click)="onCancel()"></mat-icon>
  </aside>
</header>
<mat-dialog-content>
  @if (savedNoteTakerGlobalConfig.value) {
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [dynamicHeight]="true" animationDuration="750ms"
                   preserveContent [formGroup]="form">
      <mat-tab id="note-taker-global-settings-details" label="Integration">
        <mat-accordion class="full-width-accordion">
          <mat-expansion-panel id="first-expansion-panel" [expanded]="true">
            <mat-expansion-panel-header class="tabs custom-header">
              <mat-panel-title>
                <mat-slide-toggle class="with-icon"
                                  [formControl]="form.get('kyloeCall').get('active')"
                                  (click)="$event.stopPropagation()">
                  <span class="kyloe-logo"></span>
                  Kyloe call
                </mat-slide-toggle>
                @if (!form.get('kyloeCall').valid) {
                  <mat-icon [matTooltip]="kyloeCallErrorMessage">error</mat-icon>
                }
                <mat-panel-description>
                  Edit the name and config of the bot that joins your calls
                </mat-panel-description>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-kyloe-call-settings
              [form]="form.get('kyloeCall')"
              (domainAdded)="addDomain()"
              (domainRemoved)="removeDomain($event)"></app-kyloe-call-settings>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-slide-toggle class="with-icon" [formControl]="form.get('ringover').get('enabled')"
                                  (click)="$event.stopPropagation()">
                  <img class="integration-logo slide-icon" src="assets/images/logo-ringover.png" alt="ms teams outline">
                  Ringover
                </mat-slide-toggle>
                @if (!form.get('ringover').valid) {
                  <mat-icon matTooltip="Make sure that all field are filled out.">error</mat-icon>
                }
                <mat-panel-description>
                  Include your API key to connect to Ringover
                </mat-panel-description>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-ringover-settings
              [form]="form.get('ringover')"
              [isApiKeySet]="savedNoteTakerGlobalConfig.value.ringover.isApiKeySet"
              [isWebHookKeySet]="savedNoteTakerGlobalConfig.value.ringover.isWebHookKeySet"
            ></app-ringover-settings>
          </mat-expansion-panel>
          <mat-expansion-panel id="last-expansion-panel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-slide-toggle class="with-icon" [formControl]="form.get('eightByEight').get('enabled')"
                                  (click)="$event.stopPropagation()">
                  8x8
                </mat-slide-toggle>
                @if (!form.get('eightByEight').valid) {
                  <mat-icon matTooltip="Make sure that all fields are filled out.">error</mat-icon>
                }
                <mat-panel-description>
                  Include your API key and secret to connect to 8x8
                </mat-panel-description>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-eight-by-eight-settings
              [form]="form.get('eightByEight')"
              [isApiKeySet]="saved8x8Config.value?.isApiKeySet"
              [isApiSecretSet]="saved8x8Config.value?.isApiSecretSet"
            ></app-eight-by-eight-settings>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-tab>
      <mat-tab id="note-taker-call-options" label="Call options">
        <div class="call-options-tab">
          <mat-slide-toggle [formControl]="form.get('saveTranscriptAsFile')">
            Save transcript as a File in Bullhorn
          </mat-slide-toggle>
          <mat-icon
            class="call-option-info-icon"
            matTooltip="When enabled, the full call transcript will be saved as a File attachment on the record in
            Bullhorn. The call summary will always be saved as a Note regardless of this setting."
            matTooltipShowDelay="200">
            info_outline
          </mat-icon>
        </div>
        <div class="call-options-tab" *ffEnabled="oneNotePerCallFlagKey">
          <mat-slide-toggle [formControl]="form.get('oneNotePerCall')">
            One Note per call
          </mat-slide-toggle>
          <mat-icon
            class="call-option-info-icon"
            matTooltip="When enabled, a single Note is created for the entire call and shared across all participants. When disabled (default), each participant gets their own Note."
            matTooltipShowDelay="200">
            info_outline
          </mat-icon>
        </div>
      </mat-tab>
    </mat-tab-group>
  } @else {
    <span class="spinner-container">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10" />
      </svg>
    </span>
  }
</mat-dialog-content>
<section mat-dialog-actions class="footer-btns">
  <button class="danger-btn-hover" (click)="onCancel()" tabindex="0">cancel</button>
  <button type="submit" (click)="onSave()" [disabled]="!form.valid" tabindex="0">save</button>
</section>

